<ngx-spinner size="medium" color="#fff" type="ball-scale-multiple"></ngx-spinner>

<header class="header">
  <div class="container">
    <div class="logo" *ngIf="domain == 'hansons'"><img style="max-height: 64px;" src="assets/images/hansons-logo.png" alt="Hansons"></div>
    <div class="logo" *ngIf="domain == 'paramount'"><img style="max-height: 64px" src="assets/images/paramount-logo.png" alt="Paramount Builders"></div>
  </div>
</header>

<main class="main-content">
  <div class="container">
    <ng-container *ngIf="uploadView">
      <h1 class="main-title">Upload documents</h1>
      <div class="upload-nav">
        <div class="upload-item" (click)="saveNext('step1')"
          [ngClass]="{'active': documentType == 'step1', 'complete': checkDocumentsData?.stateIssuerIdAck == true }">
          <span *ngIf="!checkDocumentsData?.stateIssuerIdAck">1</span>
          <img *ngIf="checkDocumentsData?.stateIssuerIdAck" src="assets/images/check-icon.svg" alt="check">
          State Issued ID
        </div>
        <div class="upload-item" (click)="saveNext('step2')"
          [ngClass]="{'active': documentType == 'step2', 'complete': checkDocumentsData?.proofOfIncomeAck == true }">
          <span *ngIf="!checkDocumentsData?.proofOfIncomeAck">2</span>
          <img *ngIf="checkDocumentsData?.proofOfIncomeAck" src="assets/images/check-icon.svg" alt="check">
          Proof of Income
        </div>
        <div class="upload-item" (click)="saveNext('step3')"
          [ngClass]="{'active': documentType == 'step3', 'complete': checkDocumentsData?.otherDocumentAck == true}">
          <span *ngIf="!checkDocumentsData?.otherDocumentAck">3</span>
          <img *ngIf="checkDocumentsData?.otherDocumentAck" src="assets/images/check-icon.svg" alt="check">
          Other Documents
        </div>
      </div>
      <div class="stepWrap">
        <div [hidden]="documentType !== 'step1'" class="row" id="step1">
          <div class="col-50">
            <div class="upload-col">
              <p class="upload-col-title">Front</p>
              <div class="uplodebox-row">
                <!-- <div class="uplodebox" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"> -->
                <div class="uplodebox">
                  <div class="uploader" [ngClass]="{'highlight': isDragging}">
                    <div>
                      <img src="assets/images/upload-icon.svg" alt="File">
                      <label for="stateIssuedId">Choose File</label>
                    </div>
                    <input type="file" id="stateIssuedId" (change)="onFileSelected($event, 'step1', 'front')"
                      accept="image/*, application/pdf">
                  </div>
                </div>

                <div class="preview-wrap step1" *ngIf="frontFileType === 'image' || frontFileType === 'pdf'">
                  <div class="image-preview" *ngIf="frontFileType === 'image'">
                    <div style="position: relative;" *ngFor="let file of frontFile; let i = index">
                      <img class="image" [src]="file.url" [alt]="file?.name">
                      <img class="cancel" (click)="deleteUploadedFile(i, 'step1', 'front')"
                        src="assets/images/cancel-icon.svg" alt="Cancel">
                    </div>
                  </div>

                  <ng-container *ngIf="frontFileType === 'pdf'">
                    <div class="document-preview" *ngFor="let file of frontFile; let i = index">
                      <div class="document-container">
                        <div class="document-wrap">
                          <img class="document-icon" src="assets/images/pdf-icon.svg" alt="Document">
                          <div class="document-name">{{file?.name}}</div>
                        </div>
                        <img class="cancel" (click)="deleteUploadedFile(i, 'step1', 'front')"
                          src="assets/images/cancel-icon.svg" alt="Cancel">
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>
              <div class="hints">
                <p>Supported format: JPEG, PNG, PDF, Word</p>
                <p>Maximum size: 10 MB</p>
              </div>
            </div>
          </div>

          <div class="col-50">
            <div class="upload-col">
              <p class="upload-col-title">Back</p>
              <div class="uplodebox-row">
                <div class="uplodebox">
                  <div class="uploader">
                    <div>
                      <img src="assets/images/upload-icon.svg" alt="Camera">
                      <label for="photo">Choose File</label>
                    </div>
                    <input type="file" id="stateIssuedId" (change)="onFileSelected($event, 'step1', 'back')"
                      accept="image/*, application/pdf">
                  </div>
                </div>

                <div class="preview-wrap step1" *ngIf="backFileType === 'image' || backFileType === 'pdf'">
                  <div class="image-preview" *ngIf="backFileType === 'image'">
                    <div style="position: relative;" *ngFor="let file of backFile; let i = index">
                      <img class="image" [src]="file.url" [alt]="file?.name">
                      <img class="cancel" (click)="deleteUploadedFile(i, 'step1', 'back')"
                        src="assets/images/cancel-icon.svg" alt="Cancel">
                    </div>
                  </div>
                  <ng-container *ngIf="backFileType === 'pdf'">
                    <div class="document-preview" *ngFor="let file of backFile; let i = index">
                      <div class="document-container">
                        <div class="document-wrap">
                          <img class="document-icon" src="assets/images/pdf-icon.svg" alt="Document">
                          <div class="document-name">{{file?.name}}</div>
                        </div>
                        <img class="cancel" (click)="deleteUploadedFile(i, 'step1', 'back')"
                          src="assets/images/cancel-icon.svg" alt="Cancel">
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="hints">
                <p>Supported format: JPEG, PNG, PDF, Word</p>
                <p>Maximum size: 10 MB</p>
              </div>
            </div>
          </div>
        </div>

        <div [hidden]="documentType !== 'step2'" class="row" id="step2">
          <div class="col-50">
            <div class="upload-col">
              <div class="uplodebox-row">
                <div class="uplodebox">
                  <div class="uploader">
                    <div>
                      <img src="assets/images/upload-icon.svg" alt="Camera">
                      <label for="proofOfIncome">Choose File</label>
                    </div>
                    <input type="file" multiple id="proofOfIncome" accept="image/*, application/pdf"
                      (change)="onFileSelected($event, 'step2')">
                  </div>
                </div>
              </div>
              <div class="hints">
                <p>Supported format: JPEG, PNG, PDF, Word</p>
                <p>Maximum size: 10 MB</p>
              </div>
            </div>
          </div>
          <div class="col-50">
            <div class="upload-col">
              <div class="preview-wrap" *ngIf="proofOfIncomeFileType === 'image' || proofOfIncomeFileType === 'pdf'">
                <div class="image-preview" *ngIf="proofOfIncomeFileType === 'image'">
                  <div style="position: relative;" *ngFor="let file of proofOfIncomeFiles; let i = index">
                    <img class="image" [src]="file.url" [alt]="file?.name">
                    <img class="cancel" (click)="deleteUploadedFile(i, 'step2')" src="assets/images/cancel-icon.svg"
                      alt="Cancel">
                  </div>
                </div>
                <ng-container *ngIf="proofOfIncomeFileType === 'pdf'">
                  <div class="document-preview" *ngFor="let file of proofOfIncomeFiles; let i = index">
                    <div class="document-container">
                      <div class="document-wrap">
                        <img class="document-icon" src="assets/images/pdf-icon.svg" alt="Document">
                        <div class="document-name">{{file?.name}}</div>
                      </div>
                      <img class="cancel" (click)="deleteUploadedFile(i, 'step2')" src="assets/images/cancel-icon.svg"
                        alt="Cancel">
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div [hidden]="documentType !== 'step3'" class="row" id="step3">
          <ng-container
            *ngIf="!checkDocumentsData?.stateIssuerIdAck || !checkDocumentsData?.proofOfIncomeAck || !checkDocumentsData?.otherDocumentAck">
            <div class="col-50">
              <div class="upload-col">
                <div class="uplodebox-row">
                  <div class="uplodebox">
                    <div class="uploader">
                      <div>
                        <img src="assets/images/upload-icon.svg" alt="Camera">
                        <label for="otherDocument">Choose File</label>
                      </div>
                      <input type="file" multiple id="otherDocument" accept="image/*, application/pdf"
                        (change)="onFileSelected($event, 'step3')">
                    </div>
                  </div>
                </div>
                <div class="hints">
                  <p>Supported format: JPEG, PNG, PDF, Word</p>
                  <p>Maximum size: 10 MB</p>
                </div>
              </div>
            </div>
            <div class="col-50">
              <div class="upload-col">
                <div class="preview-wrap" *ngIf="otherDocumentFileType === 'image' || otherDocumentFileType === 'pdf'">
                  <div class="image-preview" *ngIf="otherDocumentFileType === 'image'">
                    <div style="position: relative;" *ngFor="let file of otherDocumentFiles; let i = index">
                      <img class="image" [src]="file.url" [alt]="file?.name">
                      <img class="cancel" (click)="deleteUploadedFile(i, 'step3')" src="assets/images/cancel-icon.svg"
                        alt="Cancel">
                    </div>
                  </div>
                  <ng-container *ngIf="otherDocumentFileType === 'pdf'">
                    <div class="document-preview" *ngFor="let file of otherDocumentFiles; let i = index">
                      <div class="document-container">
                        <div class="document-wrap">
                          <img class="document-icon" src="assets/images/pdf-icon.svg" alt="Document">
                          <div class="document-name">{{file?.name}}</div>
                        </div>
                        <img class="cancel" (click)="deleteUploadedFile(i, 'step3')" src="assets/images/cancel-icon.svg"
                          alt="Cancel">
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <div style="padding: 20px 15px; text-align: center; width: 100%;"
            *ngIf="checkDocumentsData?.stateIssuerIdAck && checkDocumentsData?.proofOfIncomeAck && checkDocumentsData?.otherDocumentAck">
            <p style="font-size: 20px; font-weight: 500; color: green;">All document are uploaded</p>
          </div>

        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!uploadView">
      <div style="text-align: center; padding-top: 90px;">
        <h1 style="font-size: 20px; font-weight: 500; color: green; margin-bottom: 10px;" *ngIf="successMsg">
          {{successMsg}}</h1>
        <p *ngIf="!successMsg" style="margin-bottom: 10px;">Your link has been expired</p>
        <a *ngIf="domain == 'hansons'" href="https://hansons.com/">Go to home page</a>
        <a *ngIf="domain == 'paramount'" href="https://paramountbuilders.com/">Go to home page</a>
      </div>
    </ng-container>
  </div>
</main>

<ng-container *ngIf="uploadView">
  <footer class="footer">
    <div class="container">
      <div [hidden]="documentType !== 'step1'">
        <!-- <button type="button" class="btn btn-cancel">Cancel</button> -->
        <!-- [disabled]="!(frontFile && frontFile.length) || !(backFile && backFile.length)" -->
        <button type="button" (click)="saveNext('step2')" class="btn btn-next">Next</button>
      </div>
      <div [hidden]="documentType !== 'step2'">
        <button type="button" (click)="preview('step1')" class="btn btn-cancel">Previous</button>
        <!-- [disabled]="!(proofOfIncomeFiles && proofOfIncomeFiles.length)" -->
        <button type="button" (click)="saveNext('step3')" class="btn btn-next">Next</button>
      </div>
      <div [hidden]="documentType !== 'step3'">
        <button type="button" (click)="preview('step2')" class="btn btn-cancel">Previous</button>
        <!-- [disabled]="(checkDocumentsData?.stateIssuerIdAck && checkDocumentsData?.proofOfIncomeAck) && !(otherDocumentFiles && otherDocumentFiles.length)" -->
        <button type="button" (click)="saveNext('upload')" class="btn btn-next">Upload</button>
      </div>
    </div>
  </footer>
</ng-container>

<router-outlet></router-outlet>